<template>
  <div class="support-message-attachment">
    <image-preview v-if="src" :images="[src]">
      <img :src="src" alt="Support attachment" />
    </image-preview>
    <div v-else-if="loading" class="support-message-image-loading" aria-label="Loading support attachment">
      <a-icon icon="line-md:loading-alt-loop" width="28" height="28" />
    </div>
    <a-alert v-else-if="failed" message="The image could not be loaded." type="warning" show-icon />
  </div>
</template>

<script>
import { Alert } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import ImageViewer from '@/components/entities/viewer/image-viewer.vue'

const { mapActions } = createNamespacedHelpers('agent')

export default {
  components: {
    'a-alert': Alert,
    'image-preview': ImageViewer
  },
  props: {
    attachment: {
      type: Object,
      required: true
    },
    conversationId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      src: '',
      loading: false,
      failed: false,
      requestId: 0
    }
  },
  computed: {
    attachmentKey() {
      return `${this.conversationId}:${this.attachment.file_id}:${this.attachment.status}`
    }
  },
  watch: {
    attachmentKey: {
      handler() {
        this.loadAttachment()
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['getSupportAttachmentUrl']),

    async loadAttachment() {
      const requestId = ++this.requestId
      this.src = ''
      this.failed = false

      if (this.attachment.status !== 'ready') {
        this.failed = true
        return
      }

      this.loading = true
      try {
        const src = await this.getSupportAttachmentUrl({
          fileId: this.attachment.file_id,
          conversationId: this.conversationId
        })
        if (requestId === this.requestId) this.src = src
      } catch (error) {
        if (requestId === this.requestId) this.failed = true
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.support-message-attachment {
  margin-top: 4px;
}

.support-message-attachment img,
.support-message-image-loading {
  width: 320px;
  max-width: 100%;
  max-height: 320px;
  border-radius: var(--border-radius);
}

.support-message-attachment img {
  display: block;
  object-fit: contain;
  cursor: pointer;
}

.support-message-image-loading {
  display: flex;
  height: 180px;
  align-items: center;
  justify-content: center;
  background: var(--bg-row-hover);
}
</style>
